import {
  ADD_To_CART,
  REDUCE_QUANTITY,
  EDIT_QUANTITY,
  REMOVE_FROM_CART,
  CLEAR_CART,
  REDUCE_PROMO,
  ADD_PROMO_ITEM,
  REMOVE_FROM_CART_PROMO_ITEM,
  EDIT_QUANTITY_PROMO,
  SET_USED_COMPONENTS,
  EDIT_PRODUCT,
  UPDATE_PROMOTION,
} from "./actionTypes";
import instance from "./instance";
import { batch } from "react-redux";
import { getParentCategories } from "../../Components/Menu/Helpers";
export const edit_quantity = (
  index,
  store_product,
  quantity,
  change,
  PromoItem,
  isPreordering = false,
  maxAddableQuantity = null
) => {
  return async (dispatch, getState) => {
    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    let parentCategories = null;
    if (store_product.category_is_child) {
      ({ parentCategories } = getParentCategories(
        store_product.category_id,
        getState().store.store.categories
      ));
    }
    await dispatch({
      type: !PromoItem ? EDIT_QUANTITY : EDIT_QUANTITY_PROMO,
      payload: { product: index, quantity: quantity },
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      parentCategories: parentCategories,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
    });
    await dispatch({
      type: REDUCE_QUANTITY,
      payload: {
        product: store_product,
        change,
        isPreordering,
        maxAddableQuantity,
        fromEditQuantity: true,
      },
    });

    if (
      getState().store.store.settings.enable_abandoned_carts ||
      (getState().store.store.settings.enable_sharing_carts_staff &&
        getState().store.store.settings.enable_sharing_carts)
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
  };
};
export const clearCart = (promo_id) => {
  return async (dispatch, getState) => {
    if (promo_id) {
      dispatch({
        type: REDUCE_PROMO,
        payload: promo_id,
      });
    }

    dispatch({
      type: CLEAR_CART,
    });
    dispatch({ type: SET_USED_COMPONENTS, payload: {} });

    if (
      getState().store.store.settings.enable_abandoned_carts ||
      (getState().store.store.settings.enable_sharing_carts_staff &&
        getState().store.store.settings.enable_sharing_carts)
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
  };
};

export const add_to_cart = (product) => {
  return async (dispatch, getState) => {
    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    let { parentCategories, nonMingledParentCategory } =
      product.parentCategories || {};

    delete product.parentCategories;

    await dispatch({
      type: ADD_To_CART,
      payload: product,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      nonMingledParentCategory: nonMingledParentCategory,
      parentCategories: parentCategories,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
    });

    await dispatch({
      type: REDUCE_QUANTITY,
      payload: {
        product: product,
        change: product.quantity,
        isPreordering: product.is_preordered,
      },
    });

    if (
      getState().store.store.settings.enable_abandoned_carts ||
      (getState().store.store.settings.enable_sharing_carts_staff &&
        getState().store.store.settings.enable_sharing_carts)
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
  };
};

export const remove_from_cart = (
  product_index,
  product,
  PromoItem,
  disablePreordering = false
) => {
  return async (dispatch, getState) => {
    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;

    let parentCategories = null;
    if (product.category_is_child) {
      ({ parentCategories } = getParentCategories(
        product.category_id,
        getState().store.store.categories
      ));
    }

    await dispatch({
      type: !PromoItem ? REMOVE_FROM_CART : REMOVE_FROM_CART_PROMO_ITEM,
      payload: product_index,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      parentCategories: parentCategories,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
    });

    await dispatch({
      type: REDUCE_QUANTITY,
      payload: {
        product: product,
        change: -product.quantity,
        isPreordering: product.is_preordered,
        disablePreordering: disablePreordering,
      },
    });
    if (
      getState().store.store.settings.enable_abandoned_carts ||
      (getState().store.store.settings.enable_sharing_carts_staff &&
        getState().store.store.settings.enable_sharing_carts)
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
  };
};

// Promotions Products

export const add_promo_item = (product) => {
  return async (dispatch, getState) => {
    const smart_promos = getState().store.store.smart_promos;

    await dispatch({
      type: ADD_PROMO_ITEM,
      payload: product,
      smart_promos: smart_promos,
    });
    await dispatch({
      type: REDUCE_QUANTITY,
      payload: {
        product: product,
        change: product.quantity,
        isPreordering: product.is_preordered,
      },
    });
    if (
      getState().store.store.settings.enable_abandoned_carts ||
      (getState().store.store.settings.enable_sharing_carts_staff &&
        getState().store.store.settings.enable_sharing_carts)
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
  };
};

export const editProduct = (payload) => {
  return async (dispatch, getState) => {
    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    let { parentCategories, nonMingledParentCategory } =
      payload.parentCategories || {};

    delete payload.parentCategories;

    await dispatch({
      type: EDIT_PRODUCT,
      payload: payload,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      nonMingledParentCategory: nonMingledParentCategory,
      parentCategories: parentCategories,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
    });

    if (
      getState().store.store.settings.enable_abandoned_carts ||
      (getState().store.store.settings.enable_sharing_carts_staff &&
        getState().store.store.settings.enable_sharing_carts)
    )
      try {
        const res = await instance.post("/save_abandoned_cart/", {
          cart: getState().cart,
          customers: getState().customers,
          branch: getState().branch,
          language: getState().store.language,
        });
        if (res.data.success)
          dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
      } catch (e) {}
    // dispatch({
    //   type: REDUCE_QUANTITY,
    //   payload: {
    //     product: product,
    //     change: product.quantity,
    //     isPreordering: product.is_preordered,
    //   },
    // });
  };
};

export const loadCart = (cart_uuid, history, new_address) => {
  return async (dispatch, getState) => {
    try {
      const res = await instance.get(
        `/load_cart/?cart=${cart_uuid}`.concat(
          new_address === "1" ? "&new_address=1" : ""
        )
      );
      if (res.data.success) {
        await dispatch({
          type: "SET_LANGUAGE",
          payload: res.data.data.language,
        });
        await dispatch({ type: "SET_ABANDONED_CART", payload: res.data.id });
        await dispatch({
          type: "LOAD_CART_JSON",
          payload: res.data.data.cart_json,
        });
        await dispatch({
          type: "LOAD_ADDRESS_JSON",
          payload: {
            address: res.data.data.address_json,
            name: res.data.data.name,
            phone: res.data.data.phone,
            email: res.data.data.email,
          },
        });
        if (res.data.data.branch_json)
          await dispatch({
            type: "LOAD_BRANCH_JSON",
            payload: res.data.data.branch_json,
          });

        history.replace("/checkout/confirmation");
      }
    } catch (e) {}
  };
};

export const updatePromotions = () => {
  return async (dispatch, getState) => {
    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    const deliveryTime = getState().deliveryTime;
    await dispatch({
      type: UPDATE_PROMOTION,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      updatePromotionQuantity: false,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
      deliveryTime,
    });
  };
};
